


























































































































































































































import { Component, Prop } from 'vue-property-decorator';
import {
  GridApi,
  GridOptions,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { Snotify } from '@/snotify/Snotify';
import BuscadorOperacionCrud from '@/reusable/Grid/BuscadorOperacionCrud.vue';
import StepTitle from '@/reusable/Mantenedor/StepTitle.vue';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { fetchReportesSerie } from '../fetchReporteSerie';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import Confirmation from '@/components/Confirmation.vue';
import { actionsEvent } from '@/setup';
@Component({
  components: {
    StepTitle,
    BuscadorOperacionCrud,
    MantenedorGridSinCodigo,
    FormFieldsContainer,
    'app-confirmacion': Confirmation,
  },
})
export default class TelcoFormPlanes extends ComponenteBase {
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.MantenedorTelcoEditar;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: null }) telcoid: any;

  /* ComponenteBase */
  ordesList: any[] = [];
  plan: any;
  tipo: any;
  id: any = '';
  showReporteGenerado: boolean = false;
  showReporteGeneradoEditar: boolean = false;
  dialogConfirmacion: boolean = false;
  planlist: any[] = [];
  tiposConsumos: string[] = [];
  idEliminar: any = '';
  telcoidEliminar: any = '';
  nombrePlanElminar: any = '';
  gridApi: GridApi = null;
  currentNamePlan: string = '';

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'TelcoId',
        field: 'telcoid',
        lockVisible: true,
        hide: true,
      },
      {
        headerName: 'Id',
        field: 'id',
        lockVisible: true,
        hide: true,
      },
      {
        headerName: 'Plan',
        field: 'plan',
        lockVisible: true,
      },
      {
        headerName: 'idsim',
        field: 'tiposimid',
        lockVisible: true,
        hide: true,
      },
      {
        headerName: 'Tipo',
        field: 'tipo',
        lockVisible: true,
      },
      {
        headerName: 'Consumo de Datos',
        field: 'telconsumo_datos',
        lockVisible: true,
      },
      {
        headerName: 'Tipo de Consumo',
        field: 'tipo_consumo',
        lockVisible: true,
      },
    ],
    pagination: true,
    paginationPageSize: 5,
    onGridReady: this.handleGridReady,
  };
  formFields: FormFieldDefMap = {
    id: {
      label: 'Id',
      id: this.id,
      value: this.id,
    },
    plan: {
      label: 'Plan',
      id: '',
      value: '',
    },
    tipo: {
      label: 'Tipo',
      id: '',
      value: '',
    },
    consumo: {
      label: 'Consumo de Datos',
      id: '',
      value: '',
    },
    tipoConsumo: {
      label: 'Tipo de Consumo',
      id: '',
      value: '3',
    },
  };

  readonly $snotify: Snotify = null;
  readonly loadingService = new LoadingService();

  async getplan() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        telcoid: this.telcoid,
      },
      'mantenedor_telco/get_plan_crear'
    )
      .then((data: any) => {
        if (data.data.MENSAJE_RESPUESTA == 'sin registros') {
          this.formFields.plan.value = '';

          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        } else if (data.data.CODIGO_RESPUESTA == '1') {
          self.planlist = data.data.TIPO;
          self.tiposConsumos = data.data.TIPO_CONSUMO;
          self.id = Number(data.data.CONTADOR[0].max) + 1;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  async getReportes(telcoid: any) {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { telcoid: self.telcoid },
      'mantenedor_telco/plan'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.id = 1;
          return;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getReportes(this.telcoid);

    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }
  crear_plan() {
    this.formFields.id.value = this.id;
    this.formFields.tipoConsumo.value = '3';
    this.showReporteGenerado = true;
  }
  closeReporte() {
    Object.keys(this.formFields).forEach(key => {
      if (key !== 'id') {
        if (key === 'tipoConsumo') {
          this.formFields[key].value = '3';
        } else {
          this.formFields[key].value = '';
        }
      }
    });
    this.showReporteGenerado = false;
    this.showReporteGeneradoEditar = false;
  }
  async guardar() {
    let self = this;
    if (this.formFields.plan.value == '') {
      self.$snotify.error('Debe incluir un Plan', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    if (this.formFields.tipo.value == '') {
      self.$snotify.error('Debe incluir el tipo de SIM', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    const telconsumo_datos = this.formFields.consumo.value as any;
    if (!telconsumo_datos.trim()) {
      self.$snotify.error('Debe incluir un Consumo', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    const pattern: RegExp = /[^0-9.]+/g;
    if (pattern.test(telconsumo_datos)) {
      self.$snotify.error(
        'El campo Consumo solo permite valores numéricos enteros o decimales separados por punto (.) y sin espacios Ejemplo (2.2)',
        { timeout: 3000 }
      );
      this.loadingService.hideLoading();
      return;
    }
    return fetchReportesSerie(
      {
        usuarioid: JSON.parse(localStorage.getItem('user')).id,
        usuariorut: JSON.parse(localStorage.getItem('user')).rutClienteDefecto,
        clienteid: JSON.parse(localStorage.getItem('clienteDefecto')),
        telcoid: this.telcoid,
        bmoduloid: this.funcionalidad,
        telcoplanid: this.formFields.id.value,
        telcoplanname: this.formFields.plan.value,
        tiposimid: this.formFields.tipo.value,
        telconsumo_datos,
        tipo_consumo: this.formFields.tipoConsumo.value,
      },
      'mantenedor_telco/crear_plan'
    )
      .then(async (data: any) => {
        if (self.formFields.plan.value == '') {
          self.$snotify.error('El campo Estado debe ser diligenciado', {
            timeout: 3000,
          });
        }
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.ordesList = await this.getReportes(this.telcoid);
          this.gridApi.setRowData(this.ordesList);
          self.id = self.id + 1;
          self.$snotify.success(
            'Ha creado con éxito el plan :' + this.formFields.plan.value,
            { timeout: 3000 }
          );
          this.closeReporte();
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return;
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ha ocurrido un error al crear el plan :' +
            this.formFields.plan.value,
          { timeout: 3000 }
        );
        this.closeReporte();
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };

  accionEliminar: PermisoAccion = {
    accionCodigo: 5,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionEditar,
    this.accionEliminar,
  ];
  constructor() {
    super();
    actionsEvent.onEditar(this.handleVerEditarClickPlan);
    actionsEvent.onEliminar(this.handleElminarPlan);
  }
  tipo_sim: any = {};
  handleVerEditarClickPlan(params: ICellRendererParams) {
    this.showReporteGeneradoEditar = true;
    this.formFields.id.value = params.data.id;
    this.currentNamePlan = params.data.plan;
    this.formFields.plan.value = params.data.plan;
    const validartTipoConsumo =
      params.data.tipo_consumo === 'KB'
        ? '1'
        : params.data.tipo_consumo === 'MB'
        ? '2'
        : params.data.tipo_consumo === 'GB'
        ? '3'
        : '';
    this.formFields.consumo.value = params.data.telconsumo_datos;
    this.formFields.tipoConsumo.value = validartTipoConsumo;
    this.formFields.tipo.value = {
      id: params.data.tiposimid,
      tipo_sim: params.data.tipo,
    };
    this.telcoid = params.data.telcoid;
  }
  async editarPlan() {
    let self = this;
    this.loadingService.showLoading();
    if (this.formFields.plan.value == '') {
      self.$snotify.error('Debe incluir un Plan', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    if (this.formFields.tipo.value == '') {
      self.$snotify.error('Debe incluir el tipo de SIM', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    const telconsumo_datos = this.formFields.consumo.value as any;
    if (!telconsumo_datos.trim()) {
      self.$snotify.error('Debe incluir un Consumo', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    const pattern: RegExp = /[^0-9.]+/g;
    if (pattern.test(telconsumo_datos)) {
      self.$snotify.error(
        'El campo Consumo solo permite valores numéricos enteros o decimales separados por punto (.) y sin espacios Ejemplo (2.2)',
        { timeout: 3000 }
      );
      this.loadingService.hideLoading();
      return;
    }
    if (!this.formFields.tipoConsumo.value) {
      self.$snotify.error('Debe incluir un Tipo de Consumo', { timeout: 3000 });
      this.loadingService.hideLoading();
      return;
    }
    this.tipo_sim = this.formFields.tipo.value;
    return fetchReportesSerie(
      {
        usuarioid: JSON.parse(localStorage.getItem('user')).id,
        usuariorut: JSON.parse(localStorage.getItem('user')).rutClienteDefecto,
        clienteid: JSON.parse(localStorage.getItem('clienteDefecto')),
        bmoduloid: this.funcionalidad,
        telcoplanname: this.formFields.plan.value,
        tiposimid: self.tipo_sim.id,
        telcoid: self.telcoid,
        telcoplanid: this.formFields.id.value,
        telconsumo_datos,
        tipo_consumo: this.formFields.tipoConsumo.value,
        current_name_plan: this.currentNamePlan,
      },
      'mantenedor_telco/editar_plan'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.ordesList = await this.getReportes(this.telcoid);
          this.gridApi.setRowData(this.ordesList);
          this.closeReporte();
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.closeReporte();
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  closeReporteEditar() {
    Object.keys(this.formFields).forEach(key => {
      if (key !== 'id') {
        if (key === 'tipoConsumo') {
          this.formFields[key].value = '3';
        } else {
          this.formFields[key].value = '';
        }
      }
    });
    this.showReporteGeneradoEditar = false;
  }

  handleElminarPlan(params: ICellRendererParams) {
    this.idEliminar = params.data.id;
    this.telcoidEliminar = this.telcoid;
    this.dialogConfirmacion = true;
    this.nombrePlanElminar = params.data.plan;
  }
  async confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;

    if (val) {
      let self = this;
      this.loadingService.showLoading();

      return fetchReportesSerie(
        {
          usuarioid: JSON.parse(localStorage.getItem('user')).id,
          usuariorut: JSON.parse(localStorage.getItem('user'))
            .rutClienteDefecto,
          clienteid: JSON.parse(localStorage.getItem('clienteDefecto')),
          bmoduloid: this.funcionalidad,
          telcoid: this.telcoidEliminar,
          telcoplanid: this.idEliminar,
        },
        'mantenedor_telco/eliminar_plan'
      )
        .then(async (data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.ordesList = await this.getReportes(this.telcoid);
            this.gridApi.setRowData(this.ordesList);

            self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
              timeout: 3000,
            });
          } else {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        })
        .finally(() => {
          this.loadingService.hideLoading();
          return null;
        });
    }
  }

  async mounted() {
    this.getplan();
  }
}
